module.exports = __webpack_public_path__ + "img/Withdraw-gold.3aaf21df.svg";